import { useState } from 'react';
import { motion } from 'framer-motion';

const EDGE_FUNCTION_URL = `${process.env.REACT_APP_SUPABASE_URL?.trim()}/functions/v1/support-request-handler`;

export default function Contact() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus(null);
    setLoading(true);

    try {
      const res = await fetch(EDGE_FUNCTION_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${process.env.REACT_APP_SUPABASE_ANON_KEY?.trim()}`,
        },
        body: JSON.stringify({ name, email, message }),
      });

      if (!res.ok) throw new Error('Request failed');
      setStatus('success');
      setName('');
      setEmail('');
      setMessage('');
    } catch {
      setStatus('error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <section id="contact" className="py-24 bg-omnio-dark relative border-t border-omnio-charcoal">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16">
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <h2 className="text-4xl font-bold text-omnio-white mb-6">Let's start your journey.</h2>
            <p className="text-omnio-silver font-light mb-12 max-w-md">
              Whether you have questions about the system or want to inquire about early access, we're here to help you move forward.
            </p>

            <div className="space-y-6 text-omnio-gray">
              <div>
                <h4 className="text-sm font-semibold text-omnio-white uppercase tracking-wider mb-2">Email</h4>
                <p>gaurav404.gk@gmail.com</p>
              </div>
              {/* <div>
                <h4 className="text-sm font-semibold text-omnio-white uppercase tracking-wider mb-2">Office</h4>
                <p>123 Innovation Drive<br/>Tech District, San Francisco, CA 94103</p>
              </div> */}
              <div>
                <h4 className="text-sm font-semibold text-omnio-white uppercase tracking-wider mb-2">Support</h4>
                <p>omnioplay@gmail.com<br/>+1 (236) 865-0534</p>
              </div>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="bg-omnio-black p-8 rounded-2xl border border-omnio-charcoal"
          >
            <form onSubmit={handleSubmit} className="space-y-6">
              <div>
                <label className="block text-sm font-medium text-omnio-silver mb-2">Name</label>
                <input
                  type="text"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  required
                  className="w-full bg-omnio-dark border border-omnio-charcoal rounded-lg px-4 py-3 text-omnio-white focus:outline-none focus:border-omnio-silver transition-colors"
                  placeholder="John Doe"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-omnio-silver mb-2">Email</label>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  className="w-full bg-omnio-dark border border-omnio-charcoal rounded-lg px-4 py-3 text-omnio-white focus:outline-none focus:border-omnio-silver transition-colors"
                  placeholder="john@example.com"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-omnio-silver mb-2">Message</label>
                <textarea
                  rows={4}
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  required
                  className="w-full bg-omnio-dark border border-omnio-charcoal rounded-lg px-4 py-3 text-omnio-white focus:outline-none focus:border-omnio-silver transition-colors resize-none"
                  placeholder="How can we help you?"
                />
              </div>
              {status === 'success' && (
                <p className="text-sm text-omnio-silver">Message sent successfully.</p>
              )}
              {status === 'error' && (
                <p className="text-sm text-red-400">Something went wrong. Please try again.</p>
              )}
              <button
                type="submit"
                disabled={loading}
                className="w-full bg-omnio-white text-omnio-black font-semibold rounded-lg px-4 py-4 hover:bg-omnio-light transition-colors disabled:opacity-60 disabled:cursor-not-allowed"
              >
                {loading ? 'Sending...' : 'Send Message'}
              </button>
            </form>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
